// removed by extract-text-webpack-plugin
module.exports = {"heatmap":"_3CCnSKIVgGu0u6mlWU_H6c","column":"_2XNt1bou1IwucYb9cKEcMI","skeleton":"_2OXVGvWDNNHcMcZp4foQ35","square":"jwG25xpVhp12DzOe_4GEe","glowInSquare":"_2fW3hDwBLNVCtuLkQRp3VK","label":"_3_ocF-15pz4I6ZpNofWhtw","month":"_317BF1nDMIcr9V1Ywx-LPG"};


//////////////////
// WEBPACK FOOTER
// ./components/Customers/presentational/Heatmap.module.css
// module id = 2346
// module chunks = 1